import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { usePermissions } from "@/context/PermissionsContext";
import { Loader2 } from "lucide-react";
import PendingApproval from "@/pages/PendingApproval";

export default function ProtectedRoute({ children, page }) {
  const { user } = useAuth();
  const { mine } = usePermissions();
  if (user === null || (user && mine === null))
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "newcomer") return <PendingApproval />;
  if (page && user.role !== "admin" && !mine.includes(page)) {
    const first = mine[0];
    const target = first ? ({ dashboard: "/", ingredients: "/malzemeler", recipes: "/urunler", stock: "/stok", sales: "/satis", finances: "/finans", reports: "/raporlar", zreport: "/z-raporu", settings: "/ayarlar" }[first] || "/ayarlar") : "/ayarlar";
    return <Navigate to={target} replace />;
  }
  return children;
}
